import hero from "./hero.jpg";

function Header() {
  return (
    <div
      className="p-5 text-center bg-image"
      style={{
        backgroundImage: `url(${hero})`,
        backgroundRepeat: "no-repeat",
        height: "100vh",
        backgroundSize: "cover",
        boxShadow: "black 0px 40px 90px",
      }}
    >
      <div className="mask" style={{ backgroundColor: "rgba(0, 0, 0, 0.6);" }}>
        <div className="d-flex justify-content-center align-items-center h-100">
          <div className="text-white">
            <h1 className="mb-3">Welcome to HackFlix</h1>
            <a
              className="btn btn-outline-light btn-lg"
              href="#scroll-target"
              role="button"
            >
              Explore the best movies
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Header;
